import type { ErrorLike } from '@apollo/client'

import { CriticalIcon, EmptyState, Text } from '@buffer-mono/popcorn'

import type { JSX } from 'react'

interface SidebarErrorStateProps {
  heading: string
  error?: ErrorLike
}

export function SidebarErrorState({
  heading,
  error,
}: SidebarErrorStateProps): JSX.Element {
  return (
    <EmptyState variant="critical" size="small">
      <EmptyState.Icon>
        <CriticalIcon />
      </EmptyState.Icon>
      <EmptyState.Heading>{heading}</EmptyState.Heading>
      <EmptyState.Description>
        Try refreshing the page, or contact support if the issue persists.
        {error?.message && (
          <>
            {' '}
            <Text color="critical">{error.message}</Text>
          </>
        )}
      </EmptyState.Description>
    </EmptyState>
  )
}
